import { createApp, defineComponent, type h, type Component } from 'vue';

export const lazyCreateApp = (rootComponent: Component | { render: () => ReturnType<typeof h> }, rootContainer: HTMLElement | string) => {
  const component = 'render' in rootComponent ? defineComponent(rootComponent) : rootComponent;
  const el = typeof rootContainer === 'string' ? document.querySelector(rootContainer)! : rootContainer;
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          createApp(component).mount(rootContainer);
          observer.unobserve(el);
        }
      });
    });
    observer.observe(el);
  }
};
